export const SET_IS_AUTHENTICATED = 'SET_IS_AUTHENTICATED';
export const SET_PROFILE = 'SET_PROFILE';
